import { get, some } from 'lodash';
import { applicationProperties, scriptTypes } from 'constants/scripts';
import { getActiveScriptId, getActiveScriptType, getActiveScript } from 'current/selectors';
import { getScriptById, getScriptTypeForScript } from 'scripts/selectors';

const _getValidationResultByKey = (state, key) => {
  return get(state, `validations.${key}`);
};

export const getDuplicateScriptValidationResult = (state) => {
  return _getValidationResultByKey(state, 'duplicate');
};

export const getRenameScriptValidationResult = (state) => {
  return get(_getValidationResultByKey(state, 'rename'), 'resultsByKey.scriptName');
};

export const getPlantingPlanParamsValidationResult = (state) => {
  return _getValidationResultByKey(state, 'plantingPlanParams');
};

export const getPlantingPlanParamsUiValidationResult = (state) => {
  return _getValidationResultByKey(state, 'plantingPlanParamsUi');
};

export const getSeedProductSelectorValidationResult = (state) => {
  const brandsValidationResult = _getValidationResultByKey(state, 'seedProductSelectorBrands');
  const rmValuesValidationResult = _getValidationResultByKey(state, 'seedProductSelectorRmValues');
  // isInvalid for entire seed product selector form
  const isInvalid = get(brandsValidationResult, 'isInvalid', false)
    || get(rmValuesValidationResult, 'isInvalid', false);

  return {
    isInvalid,
    brandsValidationResult,
    rmValuesValidationResult
  };
};

export const getLayerValidationResultForToggling = (state) => {
  const cciLayersValidationResult = _getValidationResultByKey(state, 'cciLayers');
  const yieldLayersValidationResult = _getValidationResultByKey(state, 'yieldLayers');
  // isInvalid for all advanced scripting layers
  const isInvalid = get(cciLayersValidationResult, 'isInvalid', false)
    && get(yieldLayersValidationResult, 'isInvalid', false);

  return {
    isInvalid,
    cciLayersValidationResult,
    yieldLayersValidationResult
  };
};

export const getYieldMapsValidationResultForInitialLoad = (state) => {
  return _getValidationResultByKey(state, 'allYield');
};

export const getYieldMapsValidationResultForToggling = (state) => {
  return _getValidationResultByKey(state, 'unexcludedYield');
};

export const getZoneValidationResult = (state, zoneId) => {
  const script = getActiveScript(state);
  const scriptType = getScriptTypeForScript(script) || getActiveScriptType(state);
  const scriptId = getActiveScriptId(state);
  const validationsState = get(state, `validations`, {});
  const keyBase = `${scriptId}-zones-${zoneId}`;

  let properties;
  switch (scriptType) {
    case scriptTypes.FERTILITY:
      properties = [
        applicationProperties.FERTILIZER_RATE,
        applicationProperties.NITROGEN_RATE
      ];
      break;
    case scriptTypes.APPLICATION:
      properties = [
        applicationProperties.FERTILIZER_RATE,
        applicationProperties.RATE
      ];
      break;
    case scriptTypes.PLANTING:
      properties = [
        applicationProperties.TARGET_YIELD,
        applicationProperties.SEED_RATE,
        applicationProperties.FERTILIZER_RATE
      ]; 
      break;
    default:
      properties = [];
      break;
  }

  let validationResult = properties.reduce((result, property) => {
    result[property] = get(validationsState, `${keyBase}-${property}.resultsByKey.${property}`);
    return result;
  }, {});

  return {
    ...validationResult,
    isInvalid: some(Object.values(validationResult), property => get(property, 'isInvalid', false))
  };
};

export const getScriptValidationResult = (state, scriptId) => {
  const { zones } = getScriptById(state, scriptId);
  return {
    isInvalid: some(Object.keys(zones), zoneId => get(getZoneValidationResult(state, zoneId), 'isInvalid', false))
  };
};

export const unitTestPrivate = {
  _getValidationResultByKey
};
